import { format, parse } from "date-fns";
import { useEffect } from "react";
import BusDashboardIcon from "../../components/shared/svgs/BusDashboad";
import useDashboards from "../../hooks/useDashboards";
import useFetch from "../../hooks/useFetch";
import {
  getOperatorActiveLinesAndAgents,
  getOperatorTripsSalesAnalytics
} from "../../services/Analytics.service";
import AccountProfileUsersIcon from "../shared/svgs/AccountProfileUsersIcon";
import CalendarIcon from "../shared/svgs/CalendarIcon";

const calculateTotalPassengers = (data: any[] = []) => {
  return data.reduce(
    (total, p) =>
      total +
      p.tripSales.reduce((tripTotal: number, c: any) => tripTotal + (c.nrOfPassengers || 0), 0),
    0
  );
};

const formatDate = (dateString: string) =>
  format(parse(dateString, "dd/MM/yyyy", new Date()), "MM-dd-yyyy");

const ActiveLinesAndAgents = () => {
  const { line, from, to } = useDashboards();

  const { response: metaData, loading: metaLoading } = useFetch(
    getOperatorActiveLinesAndAgents,
    { initRequest: true }
  );

  const {
    response: rangeData,
    loading: rangeLoading,
    handleFunc: fetchRangeAnalytics
  } = useFetch(getOperatorTripsSalesAnalytics, {
    loading: true,
    resetResponseOnError: true
  });

  const {
    response: todayData,
    loading: todayLoading,
    handleFunc: fetchTodayAnalytics
  } = useFetch(getOperatorTripsSalesAnalytics, {
    loading: true,
    resetResponseOnError: true
  });

  useEffect(() => {
    if (from && to) {
      void fetchRangeAnalytics({
        startDate: formatDate(from),
        endDate: formatDate(to),
        lineId: line?.value || undefined
      });
    }
  }, [from, to, line, fetchRangeAnalytics]);

  useEffect(() => {
    const todayStr = format(new Date(), "MM-dd-yyyy");
    void fetchTodayAnalytics({
      startDate: todayStr,
      endDate: todayStr,
      lineId: line?.value || undefined
    });
  }, [line, fetchTodayAnalytics]);

  return (
    <div className="flex flex-col md:flex-row gap-4">
      <Item
        loading={rangeLoading}
        x={calculateTotalPassengers(rangeData?.data)}
        title="numri total i pasagjerëve për këtë periudhë"
        icon={<AccountProfileUsersIcon />}
      />
      <Item
        loading={metaLoading}
        x={metaData?.data.activeLines}
        title="totali i linjave aktive në platformë"
        icon={<BusDashboardIcon />}
      />
      <Item
        loading={todayLoading}
        x={calculateTotalPassengers(todayData?.data)}
        title="numri i pasagjerëve për sot"
        icon={<CalendarIcon size={24} />}
      />
    </div>
  );
};

export default ActiveLinesAndAgents;

const Item = ({
  title,
  x,
  loading,
  icon
}: {
  title: string;
  x?: number;
  loading: boolean;
  icon: React.ReactNode;
}) => (
  <div className="py-5 pl-6 pr-8 flex justify-between gap-2.5 border border-gray-200 rounded-lg w-full ">
    <div className="flex flex-col gap-2.5">
      <p className="text-2xs font-medium text-neutral uppercase">{title}</p>
      {!loading ? (
        <p className="text-2xl font-medium">{x?.toLocaleString() ?? 0}</p>
      ) : (
        <div className="w-1/2 h-[33px] bg-gray-200 rounded-lg animate-pulse" />
      )}
    </div>
    <div className="my-1 flex items-center justify-center w-12 rounded-full bg-[#ECF8F4] text-green">
      {icon}
    </div>
  </div>
);
